import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/lib/auth/auth-client";
import Page from "@/pages/tools";

export const Route = createFileRoute("/tools")({
  head: () => ({
    meta: [
      { title: "Workflow Tools | Digitally Baffled" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <ProtectedRoute requireAdmin>
      <Page />
    </ProtectedRoute>
  ),
});
